import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Box, Flex } from "rebass/styled-components";
import { HiClock, HiX } from "react-icons/hi";

import { useUnsavedDraftCount } from "MVVM/Hooks/useUnsavedDraftCount";

export const UnsavedDraftsBubble = () => {
  const unsavedCount = useUnsavedDraftCount();
  const history = useHistory();
  const location = useLocation();
  const [dismissed, setDismissed] = React.useState(false);

  const isLibraryPage = location.pathname === "/library";

  if (!unsavedCount || dismissed || isLibraryPage) {
    return null;
  }

  return (
    <CardContainer>
      <TopRow>
        <IconWrapper>
          <HiClock size={16} />
        </IconWrapper>
        <Title>
          {unsavedCount} unsaved draft{unsavedCount !== 1 ? "s" : ""} expiring
          soon
        </Title>
        <DismissButton
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            setDismissed(true);
          }}
        >
          <HiX size={14} />
        </DismissButton>
      </TopRow>
      <StatusRow>
        <StatusText>Draft clips expire 72h after creation</StatusText>
        <ViewLink onClick={() => history.push("/library")}>View</ViewLink>
      </StatusRow>
    </CardContainer>
  );
};

const CardContainer = styled(Box)`
  background-color: ${({ theme }) => theme.colors.navy};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  padding: 10px 12px;
  width: 300px;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    width: 100%;
  }
`;

const TopRow = styled(Flex)`
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

const IconWrapper = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.turbo};
  flex-shrink: 0;
`;

const Title = styled.span`
  color: ${({ theme }) => theme.colors.ice};
  flex: 1;
  font-family: Barlow, sans-serif;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StatusRow = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`;

const StatusText = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  font-family: Barlow, sans-serif;
  font-size: 12px;
  font-weight: 500;
`;

const ViewLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.envy};
  cursor: pointer;
  font-family: Barlow, sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin-left: auto;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

const DismissButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.chalkAlpha60};
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  padding: 0;
  width: 20px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.chalkAlpha20};
    color: ${({ theme }) => theme.colors.ice};
  }
`;
